export default __webpack_public_path__ + "static/media/phone-verification.08462e0b.png";